import { find, without } from 'lodash';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

export function BankAccountOpeningBalancesApi(
    $q,
    SortUtilities
) {
    const url = `${BASE_PATH_API}/newAccountSetup/bankAccount/:id/openingBalances`;
    const actions = {
        getBankAccountOpeningBalances: {
            method: 'GET',
            url
        },
        getAllBankAccountOpeningBalances: {
            method: 'GET',
            url: `${BASE_PATH_API}/newAccountSetup/bankAccount/openingBalances`,
            isArray: true
        },
        updateBankAccountBalances: {
            method: 'PUT',
            url
        },
        completeNewAccountOpeningBalances: {
            method: 'PUT',
            url: `${BASE_PATH_API}/newAccountSetup/bankAccount/openingBalances/complete`,
        }

    };

    const service = createActions(actions);

    service.shouldBeEnabled = function shouldBeEnabled() {
        return service.getAllBankAccountOpeningBalances()
            .then(function(accounts) {
                return accounts.some(account => !account.IsSetupComplete);
            });
    };

    service.getAllBankAccountOpeningBalancesSorted = function getAllBankAccountOpeningBalancesSorted() {
        return service.getAllBankAccountOpeningBalances()
            
            .then(function(bankAccounts) {
                const companyAccount = find(bankAccounts, account => account.IsCompanyAccount);
                const otherAccounts = without(bankAccounts, companyAccount);
                const sorted = SortUtilities.naturalSortByProperty(otherAccounts, 'BankAccountName');

                if (companyAccount) {
                    return [companyAccount].concat(sorted);
                }
                return sorted;
            });
    };

    service.getOpeningBalancesForAccount = function getOpeningBalancesForAccount(allBankAccounts, bankGlAccountId) {
        const bankAccount = find(allBankAccounts, function(account) {
            return parseInt(account.BankGLAccountId, 10) === parseInt(bankGlAccountId, 10);
        });

        return service.getBankAccountOpeningBalances({id: bankAccount.BankGLAccountId});
    };

    return service;
}

BankAccountOpeningBalancesApi.$inject = [
    '$q',
    'SortUtilities'
];
